import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/purchase_left.svg'


const _withScopeId = n => (_pushScopeId("data-v-764a61e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "buyer-box" }
const _hoisted_2 = { class: "buyer-box-title" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "buyer-box-title-info" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "left",
  class: "purchase-left"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "righ",
  class: "purchase-right"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"12px"} }, null, -1))
const _hoisted_10 = { class: "pay-box-info" }
const _hoisted_11 = {
  key: 0,
  class: "pay-box-price"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "qr-tip" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "wechat" }),
  /*#__PURE__*/_createTextVNode("请扫码完成支付")
], -1))

import {account} from "@/app/login";
import {CloseOutlined, CheckCircleOutlined} from "@ant-design/icons-vue";
import ScrollPagerView from "@/components/ScrollPagerView.vue";
import {onMounted, onUnmounted, reactive, watch} from "vue";
import PurchaseCard, {IExpPackageMenuItem} from "@/components/views/PurchaseCard.vue";
import {mock, mockArr, req} from "@/lib/util";
import emit from "@/lib/emit";
import {toTopic} from "@/lib/session";
import PopupBase from "@/components/PopupBase.vue";

interface IExpPackageMenuOrder {
  status: 'loading' | 'expired' | 'active'
  code_url: string
  timer: number
  expire: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PurchaseBox',
  props: {
    open: { type: Boolean }
  },
  emits: ['update:open'],
  setup(__props: any, { emit: __emit }) {


const props = __props
const emits = __emit

const info = reactive({menu: [] as IExpPackageMenuItem[], index: -1, orders: [] as IExpPackageMenuOrder[]})

onMounted(() => {
  mockArr('menu/exp_packages', 'get', 4, 8, {
    exp_package_menu_id: '@id',
    title: '@ctitle',
    origin_price: '@integer(200,400)',
    price: '@integer(100,300)',
    tip: '@ctitle(3,12)',
    tag: '@ctitle(0,8)',
    desc: '@csentence(13,52)'
  })
  req({
    url: 'menu/exp_packages', success: rs => {
      info.menu = rs
      info.orders = info.menu.map(() => ({status: 'expired', code_url: '', timer: 0, expire: 0}))
      info.index = 0
    }
  })
  watch(() => props.open, o => {
    if (o) refreshQr()
  })
  emit.on(toTopic('exp_package'), () => {
    info.orders[info.index].status = 'expired'
    emits('update:open', false)
  })
})

onUnmounted(() => {
  info.orders.forEach(i => {
    if (i.timer > 0) window.clearTimeout(i.timer)
  })
  emit.off(toTopic('exp_package'))
})

const refreshQr = () => {
  if (info.orders[info.index].expire > Date.now().valueOf()) return
  info.orders[info.index].status = 'loading'
  mock('menu/exp_package/order', 'post', {code_url: '@url'})
  req({
    url: 'menu/exp_package/order', method: 'post', data: info.menu[info.index], success: rs => {
      info.orders[info.index].status = 'active'
      info.orders[info.index].code_url = rs.code_url
      info.orders[info.index].expire = Date.now().valueOf() + (3600 * 1000)
      info.orders[info.index].timer = window.setTimeout(() => {
        info.orders[info.index].status = 'expired'
      }, 3600 * 1000)
    }
  })
}

const onCardActive = (i: number) => {
  info.index = i
  refreshQr()
}

return (_ctx: any,_cache: any) => {
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_qrcode = _resolveComponent("a-qrcode")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createBlock(PopupBase, {
    open: _ctx.open,
    "onUpdate:open": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:open',false)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _unref(account).shop?.icon ? _unref(account).shop?.icon+'-sq.90' : '',
            alt: ""
          }, null, 8, _hoisted_3),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, _toDisplayString(_unref(account).shop.shop_name), 1),
            (_unref(account).exp_packages.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, " 已有" + _toDisplayString(_unref(account).exp_packages.length) + "个活动服务包，可做 " + _toDisplayString(_unref(account).exp_packages.reduce((a, n) => a + n.balance, 0)) + "场活动 ", 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, "当前无可用活动服务包"))
          ]),
          _createVNode(_unref(CloseOutlined), {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:open',false)))
          })
        ]),
        _createVNode(_component_a_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, {
              flex: "474px",
              class: "card-box"
            }, {
              default: _withCtx(() => [
                _createVNode(ScrollPagerView, null, {
                  left: _withCtx(() => [
                    _hoisted_7
                  ]),
                  right: _withCtx(() => [
                    _hoisted_8
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_a_space, { size: 11 }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.menu, (c, k) => {
                          return (_openBlock(), _createBlock(PurchaseCard, {
                            key: k,
                            active: k == info.index,
                            card: c,
                            onClick: ($event: any) => (onCardActive(k))
                          }, null, 8, ["active", "card", "onClick"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _hoisted_9,
                _createVNode(_component_a_alert, {
                  "show-icon": "",
                  class: "card-description"
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_unref(CheckCircleOutlined))
                  ]),
                  message: _withCtx(() => [
                    _createTextVNode(_toDisplayString(info.menu[info.index].desc), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, {
              flex: "auto",
              class: "pay-box"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, [
                  (info.index>-1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, "¥" + _toDisplayString(info.menu[info.index].price), 1))
                    : _createCommentVNode("", true)
                ]),
                (info.index>-1)
                  ? (_openBlock(), _createBlock(_component_a_qrcode, {
                      key: 0,
                      "error-level": 'H',
                      status: info.orders[info.index].status,
                      value: info.orders[info.index].code_url,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((info.orders[info.index].code_url) = $event)),
                      "bg-color": "white",
                      bordered: "",
                      style: {"border-color":"#f3a233","margin-top":"15px"},
                      icon: require('@/assets/image/wepay.svg'),
                      onRefresh: refreshQr
                    }, null, 8, ["status", "value", "icon"]))
                  : _createCommentVNode("", true),
                _hoisted_12
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})